import { inject, PLATFORM_ID, signal } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { map, startWith } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { Store } from '@ngxs/store';
import { PageState } from '@core/frontend-shared';
import { CoreErrorMessageComponent } from '../components/error-message.component';
import { ERROR_PAGE_DATA_DEFAULTS } from '@core/frontend-shared';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
function CoreErrorPageGenericComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "core-error-message", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("error", ctx_r0.errorInfo());
  }
}
export let CoreErrorPageGenericComponent = /*#__PURE__*/(() => {
  class CoreErrorPageGenericComponent {
    constructor(activatedRoute, router, platformId) {
      this.activatedRoute = activatedRoute;
      this.router = router;
      this.platformId = platformId;
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.isInitialRoute = inject(Store).selectSignal(PageState.isInitialRoute);
      this.errorInfo = signal(null, ...(ngDevMode ? [{
        debugName: "errorInfo"
      }] : /* istanbul ignore next */[]));
      activatedRoute.data.pipe(takeWhileAlive(), startWith({}), map(data => this.collectErrorData()), takeWhileAlive()).subscribe(errorData => {
        this.errorInfo.set(errorData);
      });
    }
    ngAfterViewInit() {
      if (this.isInitialRoute()) {
        this.router.navigate(['/']);
      }
    }
    collectErrorData() {
      if (this.isBrowser) {
        return {
          // default/fallback error data
          ...ERROR_PAGE_DATA_DEFAULTS.ERR_GENERIC,
          // ErrorPageData may be stored in route data
          ...(this.activatedRoute.snapshot.data['errorData'] || {}),
          // ErrorPageData may be stored in history state
          ...window.history.state
        };
      } else {
        return {};
      }
    }
    static {
      this.ɵfac = function CoreErrorPageGenericComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreErrorPageGenericComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreErrorPageGenericComponent,
        selectors: [["ng-component"]],
        decls: 1,
        vars: 1,
        consts: [[3, "error"]],
        template: function CoreErrorPageGenericComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CoreErrorPageGenericComponent_Conditional_0_Template, 1, 1, "core-error-message", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.errorInfo() ? 0 : -1);
          }
        },
        dependencies: [CoreErrorMessageComponent],
        encapsulation: 2
      });
    }
  }
  return CoreErrorPageGenericComponent;
})();